import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import CLIInject from '../../_snippets/cli/inject.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Once you've built your application and have bundled assets, inject the context required by PostHog to associate the maps with the served code.`}</p>
    <CLIInject mdxType="CLIInject" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      